import { CreditNoteDetail, CreditNoteLineItem } from '@/components/CreditNote/types';
import { sumDiscountAmounts } from './discount';

export function creditWithLineItem(item: CreditNoteLineItem): boolean {
  return !!item.quantity || !!item.unitAmount;
}

export function creditNoteHasTax(creditNote: CreditNoteDetail): boolean {
  return (creditNote.totalTaxAmount ?? 0) > 0;
}

export function creditNoteHasInvoiceDiscount(creditNote: CreditNoteDetail): boolean {
  return sumDiscountAmounts(creditNote.discounts) > 0;
}

export function creditNoteHasLineItemDiscount(creditNote: CreditNoteDetail): boolean {
  return (creditNote.lineItems ?? []).some((l) => (l.lineItemDiscounts?.length ?? 0) > 0);
}
